var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "playlists-wrapper" },
    [
      _c("div", { staticClass: "md-headline" }, [_vm._v("Playlist+")]),
      _c(
        "md-layout",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.createMode,
              expression: "createMode"
            }
          ],
          attrs: { "md-flex": "100" }
        },
        [
          _c(
            "md-input-container",
            { class: { "md-input-invalid": _vm.$v.playlist.name.$error } },
            [
              _c(
                "div",
                [
                  _c("md-input", {
                    attrs: { placeholder: "Playlist name..." },
                    nativeOn: {
                      blur: function($event) {
                        return _vm.$v.playlist.name.$touch()
                      }
                    },
                    model: {
                      value: _vm.playlist.name,
                      callback: function($$v) {
                        _vm.$set(_vm.playlist, "name", $$v)
                      },
                      expression: "playlist.name"
                    }
                  }),
                  _vm.$v.playlist.name.$error && !_vm.$v.playlist.name.required
                    ? _c("span", { staticClass: "md-error" }, [
                        _vm._v("This field is required")
                      ])
                    : _vm._e(),
                  _vm.$v.playlist.name.$error &&
                  !_vm.$v.playlist.name.isUnique &&
                  !_vm.$v.playlist.name.$pending
                    ? _c("span", { staticClass: "md-error" }, [
                        _vm._v("Must be unique")
                      ])
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _c(
            "md-layout",
            { attrs: { "md-flex": "100", "md-align": "end" } },
            [
              _vm.creatingPlaylist
                ? _c("md-spinner", {
                    staticClass: "md-warn",
                    attrs: {
                      "md-indeterminate": "md-indeterminate",
                      "md-size": 35
                    }
                  })
                : _vm._e(),
              !_vm.creatingPlaylist
                ? _c("md-button", { on: { click: _vm.resetForm } }, [
                    _vm._v("Cancel")
                  ])
                : _vm._e(),
              !_vm.creatingPlaylist
                ? _c(
                    "md-button",
                    {
                      staticClass: "submit-btn md-raised md-primary",
                      attrs: { disabled: _vm.$v.$invalid },
                      on: { click: _vm.createPlaylist }
                    },
                    [_vm._v("Create")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "md-layout",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.createMode,
              expression: "!createMode"
            }
          ],
          staticClass: "playlist-details",
          attrs: { id: "playlist-index-container" }
        },
        [
          _c(
            "md-layout",
            {
              staticClass: "playlist-add",
              attrs: { id: "select-playlist-or-create-index", "md-flex": "100" }
            },
            [
              _c(
                "md-layout",
                { attrs: { "md-flex": "85" } },
                [
                  _c("playlist-selector", {
                    ref: "playListSelector",
                    staticClass: "selector",
                    attrs: { emitObject: true },
                    on: { selectedPlayList: _vm.updateSelectedPLayList },
                    model: {
                      value: _vm.playlistId,
                      callback: function($$v) {
                        _vm.playlistId = $$v
                      },
                      expression: "playlistId"
                    }
                  })
                ],
                1
              ),
              _c(
                "md-layout",
                { staticClass: "on-right", attrs: { "md-flex": "10" } },
                [
                  _c("md-spinner", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    staticClass: "md-warn",
                    attrs: {
                      "md-indeterminate": "md-indeterminate",
                      "md-size": 35
                    }
                  }),
                  _c(
                    "md-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.loading,
                          expression: "!loading"
                        }
                      ],
                      staticClass:
                        "md-icon-button md-raised md-accent md-dense btn",
                      attrs: {
                        id: "create-playlist-index",
                        "md-theme": "blue"
                      },
                      on: {
                        click: function($event) {
                          _vm.createMode = true
                        }
                      }
                    },
                    [
                      _c("md-icon", {
                        staticClass: "icon",
                        attrs: { "md-iconset": "fa fa-plus" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.hasItemsToShow
            ? _c(
                "div",
                { staticClass: "info" },
                [
                  _c("md-icon", {
                    staticClass: "md-accent",
                    attrs: { "md-iconset": "fa fa-info-circle" }
                  }),
                  _c("span", { staticClass: "md-caption" }, [
                    _vm._v("Drag and drop the playlist items to sort them.")
                  ])
                ],
                1
              )
            : _vm._e(),
          _c(
            "md-layout",
            { attrs: { id: "items-index-container", "md-flex": "100" } },
            [
              _vm.hasItemsToShow
                ? _c(
                    "SlickList",
                    {
                      staticClass: "md-list custom-list md-triple-line",
                      attrs: {
                        id: "items-list-index-playlist",
                        lockAxis: "y",
                        pressDelay: 100
                      },
                      on: {
                        "sort-start": _vm.handleDragStart,
                        "sort-end": _vm.handleDragEnd
                      },
                      model: {
                        value: _vm.selectedPlaylistItems,
                        callback: function($$v) {
                          _vm.selectedPlaylistItems = $$v
                        },
                        expression: "selectedPlaylistItems"
                      }
                    },
                    _vm._l(_vm.selectedPlaylistItems, function(item, index) {
                      return _c(
                        "SlickItem",
                        {
                          key: index,
                          staticClass:
                            "itemPlaylist md-list-item sortable-item",
                          attrs: { index: index }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "md-list-item-container" },
                            [
                              _c("md-avatar", [
                                _c("img", {
                                  attrs: {
                                    src: _vm.getVideoPoster(item),
                                    alt: item.name
                                  }
                                })
                              ]),
                              _c(
                                "div",
                                { staticClass: "md-list-text-container" },
                                [
                                  _c("span", { staticClass: "title" }, [
                                    _vm._v(_vm._s(item.name))
                                  ]),
                                  _c("span", { staticClass: "detail" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.secondsToHms(
                                          item.duration || item.videoDuration
                                        )
                                      )
                                    )
                                  ]),
                                  _c("span", { staticClass: "detail" }, [
                                    _vm._v(_vm._s(item.credit))
                                  ])
                                ]
                              ),
                              _c(
                                "md-button",
                                {
                                  staticClass:
                                    "md-icon-button md-warn md-list-action btn-icon",
                                  attrs: { id: "delete-item-index-playlist" },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeItemAt(index)
                                    }
                                  }
                                },
                                [
                                  _c("md-icon", {
                                    staticClass: "icon",
                                    attrs: { "md-iconset": "fa fa-trash-alt" }
                                  })
                                ],
                                1
                              ),
                              _c("md-divider")
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    1
                  )
                : _c("md-layout", [
                    _c(
                      "span",
                      { staticClass: "md-subheader no-results" },
                      [
                        _c("md-icon", {
                          staticClass: "md-accent",
                          attrs: { "md-iconset": "fa fa-exclamation-circle" }
                        }),
                        _vm._v("No items in this playlist")
                      ],
                      1
                    )
                  ])
            ],
            1
          ),
          _vm.hasItemsToShow
            ? _c(
                "md-layout",
                { staticClass: "btn", attrs: { "md-flex": "100" } },
                [
                  _c(
                    "md-button",
                    {
                      staticClass: "btn-child md-raised md-primary",
                      attrs: { "md-theme": "blue" },
                      on: { click: _vm.distributePlaylist }
                    },
                    [_vm._v("Distribute")]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40438fce", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40438fce","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/playlist/Playlists.vue
// module id = 663
// module chunks = 0